import React, { useRef } from 'react';
import { useOutsideClick } from '../../../utils/custom-hooks';
import './modal.scss';

function Modal({
  setAction,
  action,
  slug,
  displayMsg,
  response,
  disableJstag,
  handleDisplayMsg,
  switchJsTagMode,
  clearState,
}) {
  const modal = useRef(false);

  useOutsideClick(modal, () => setAction(false));

  const headerStyle = response ? 'success' : 'warning';
  const buttonState = response ? 'hide' : 'display';
  const buttonText = response ? 'Ok' : 'Cancel';

  const buttons = (
    <>
      <button
        className={`button disable ${buttonState}`}
        onClick={e => {
          handleDisplayMsg(e, action);
          switchJsTagMode(slug, disableJstag, action);
        }}
      >
        Yes {action}
      </button>
      <button
        className="button"
        action=""
        onClick={e => {
          clearState();
        }}
      >
        {buttonText}
      </button>
    </>
  );

  return (
    <div className="jstag-modal-container">
      <div className="modal jstag-action-modal movable-right" ref={node => (modal.current = node)}>
        <div className="content-container">
          <h1 className={headerStyle}>{displayMsg}</h1>
          {buttons}
        </div>
      </div>
    </div>
  );
}

export default Modal;
